import React from 'react';
import { MapPinned } from 'lucide-react';
import { BuyCreditsModal as SharedBuyCreditsModal, createCreditCheckoutViaSupabase } from '@rehub/buy-credits';
import { supabase, isConfigured } from '../services/supabase';
import type { UserProfile } from '../types';

interface CreditsModalProps {
  user: UserProfile;
  onClose: () => void;
  onSuccess?: () => void;
  onOpenPlans?: () => void;
}

const CreditsModal: React.FC<CreditsModalProps> = ({ user, onClose, onOpenPlans }) => (
  <SharedBuyCreditsModal
    userId={user.id}
    credits={user.credits ?? 0}
    onClose={onClose}
    appSource="planos"
    accent="orange"
    createCheckout={async (params) => {
      if (!isConfigured) throw new Error('Payment system not available.');
      return createCreditCheckoutViaSupabase(supabase, params);
    }}
    offerSlot={
      onOpenPlans ? (
        <div className="flex items-start gap-3 p-3 bg-slate-800/80 border border-slate-600 rounded-xl">
          <MapPinned size={18} className="text-orange-400 mt-0.5 flex-shrink-0" aria-hidden />
          <div className="min-w-0 flex-1">
            <p className="text-sm text-slate-200 font-medium">Need active spaces?</p>
            <p className="text-xs text-slate-400 mt-0.5">
              Monthly Active Spaces plans include publishing slots for 360 Tours and Planos.
            </p>
            <button
              type="button"
              onClick={() => {
                onClose();
                onOpenPlans();
              }}
              className="mt-2 text-sm font-semibold text-orange-400 hover:text-orange-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400 rounded"
            >
              View active space plans
            </button>
          </div>
        </div>
      ) : undefined
    }
  />
);

export default CreditsModal;
